import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/tracking/')({
  component: () => <PageStub title="Tracking" description="KPIs and metrics tracking" />,
});
